// extracted by mini-css-extract-plugin
module.exports = {"dateDetails":"meeting-date_dateDetails__2zcqI","timeRange":"meeting-date_timeRange__6nvIX"};